/**
 * Component Entry
 *
 */

import PaymentCard from './PaymentCard'
import { formatCardNumber } from './components/CardNumber'
export default PaymentCard
export * from './PaymentCard'
export { formatCardNumber }
